import { ApprovalFlowService } from "./approval-flow.service";
import { ApprovalDetailResp } from "./approval-flow.interface";

const { run } = ApprovalFlowService.useMultipleDetailApi();
const { run: getSimpleDetail } = ApprovalFlowService.useDetailApi();

interface QueryParams {
  bizType: string;
  bizIds: string[];
}

interface CacheParamsType {
  [propName: string]: string[];
}

interface CallbackType {
  (fn?: Array<ApprovalDetailResp>): void;
}

interface CacheCallbackType {
  [propName: string]: CallbackType[];
}

interface ParamsType {
  bizType: string;
  bizId: string;
}

class MultipleRequest {
  cacheParams: QueryParams | undefined;
  cacheFallback: CallbackType[] = [];

  constructor(cacheParams, cacheFallback) {
    this.cacheParams = cacheParams || [];
    this.cacheFallback = cacheFallback || [];
  }

  async request() {
    const res = await run(this.cacheParams);
    this.cacheFallback.forEach((fn) => {
      fn && fn(res?.data?.records);
    });
  }
}

const cacheParams: CacheParamsType = {};
const cacheFallback: CacheCallbackType = {};
const timers: { [propName: string]: number } = {};

export default async function request(params: ParamsType, callback: CallbackType) {
  const bizType = params.bizType;
  const timer = timers[bizType];

  if (cacheParams[bizType]) {
    cacheParams[bizType].push(params.bizId);
  } else {
    cacheParams[bizType] = [params.bizId];
  }

  if (cacheFallback[bizType]) {
    cacheFallback[bizType].push(callback);
  } else {
    cacheFallback[bizType] = [callback];
  }

  timer && clearTimeout(timer);

  timers[params.bizType] = window.setTimeout(async () => {
    const bizIds = cacheParams[bizType];
    const query = new MultipleRequest({ bizType, bizIds }, cacheFallback[bizType]);
    cacheFallback[bizType] = [];
    cacheParams[bizType] = [];

    await query.request();
  }, 200);
}
